import React, { useState, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Tabs, Dropdown, Space } from 'antd';
import { About, Lifestyle, Background, ContactDetails, EducationCareer, FamilyDetails, LookingFor, Hobbies } from './matchDetailsComponents'
import './matchDetailsComponents/matchDetails.css'
import { useLocation, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import key from '../../key';
import { FaCrown } from 'react-icons/fa';
import { FaRegCheckCircle } from 'react-icons/fa';
import { BsShieldFillCheck, BsChatHeart } from "react-icons/bs";
// import { HiStatusOnline } from "react-icons/hi";
import { compareUser, dobToAge } from '../../utilities/utilities';
import { Image } from "antd"
import { useCookies } from "react-cookie"
import { FiArrowDownCircle } from "react-icons/fi"
import { BiSelectMultiple, BiBlock } from "react-icons/bi"
import { Slide } from 'react-slideshow-image';
import { PulseLoader } from 'react-spinners';
import { useDispatch } from 'react-redux';
import { recentVisitors, shortListed, blocked, addLikes, whoVisited } from '../../Redux/features/User/userSlice';



const { TabPane } = Tabs;

function ViewProfile() {
    const [loading, setLoading] = useState(true)
    const [showPhoto, setShowPhoto] = useState("show")
    const [showBadge, setShowBadge] = useState(false)
    const [points, setPoints] = useState()
    const [db, setDb] = useState()
    const [match, setMatch] = useState()
    const [isConnected, setIsConnected] = useState()
    const { user } = useSelector(state => state.user)
    const dispatch = useDispatch()
    //eslint-disable-next-line
    const [cookies, setCookies, removeCookies] = useCookies(["x-auth-token"])
    const location = useLocation();
    const id = location.pathname.split('/')[2]


    useEffect(() => {
        const handleAddRecentVisitor = (idddd) => {
            const dataa = {
                userId: {
                    id: idddd
                },
                header: cookies['x-auth-token']
            }
            dispatch(recentVisitors(dataa))
        }
        const addWhoViewed = async (idddd) => {
            const dataa = {
                myId: user._id,
                visitorId: idddd
            }
            dispatch(whoVisited(dataa))
        }
        const fetchData = async () => {
            const result = await axios(`${key}/api/user/find-match/${id}`, {
                headers: {
                    "x-auth-token": cookies["x-auth-token"],
                },
            });
            setIsConnected(result?.data?.data?.isConnected)
            setMatch(result?.data?.data?.user);
            handleAddRecentVisitor(result?.data?.data?.user?._id);
            addWhoViewed(result?.data?.data?.user?._id);
            setPoints(result.data?.data?.points)
            if (result?.data?.data?.user?.privacy?.photo === "hide") {
                setShowPhoto("hide")
            } else if (result?.data?.data?.user?.privacy?.photo === "like" && !compareUser(user?._id, match?.acceptedInvites)) {
                setShowPhoto("like")
            } else if (result?.data?.data?.user?.privacy?.photo === "premium" && user?.userStatus.membership.membershipType === "Free") {
                setShowPhoto("premium")
            } else if (result?.data?.data?.user?.privacy?.photo === "likeAndPremium" && ((user?.userStatus.membership.membershipType === "Free") || compareUser(user?._id, match?.acceptedInvites))) {
                setShowPhoto("premium")
            } else if (result?.data?.data?.user?.privacy?.photo === "likeAndPremium" && ((user?.userStatus.membership.membershipType !== "Free") || !compareUser(user?._id, match?.acceptedInvites))) {
                setShowPhoto("like")
            }
        };
        fetchData();
        //eslint-disable-next-line
    }, []);

    setTimeout(() => {
        const getAge = () => {
            if (match?.personalDetails?.dob) {
                setDb(dobToAge(match?.personalDetails?.dob))
            }
        }
        getAge()
        if (match?.userStatus?.membership?.membershipType !== "Free") {
            setShowBadge(true)
        }
        setLoading(false)
    }, 500)
    const premiums = [
        {
            key: '1',
            icon: <BiSelectMultiple size={30} />,
            label: "Add to Shortlist",
            onClick: () => {
                handleShortList(match?._id)
            }
        }, {
            key: '2',
            label: "Block Profile",
            icon: <BiBlock size={30} />,
            onClick: () => {
                handleBlock(match?._id)
            }
        }
    ]
    const handleBlock = async (id) => {
        const data = {
            id: {
                userId: id
            },
            header: cookies['x-auth-token']
        }
        dispatch(blocked(data))
    }
    const handleShortList = async (id) => {
        const data = {
            id: {
                userId: id
            },
            header: cookies['x-auth-token']
        }
        dispatch(shortListed(data))
    }

    const handleConnect = async (id) => {
        setLoading(true)
        const data = {
            id: {
                userId: id
            },
            header: cookies['x-auth-token']
        }
        dispatch(addLikes(data))
        setIsConnected(true)
        setLoading(false)
    }

    return (
        <>
            {loading ? <div className="loading-spinner"><PulseLoader size={50} color="#fa585b" /></div> :
                <div className="container todays-matches-container">
                    <Row>
                        <Col>
                            <h5 className="pageHeading text-center">Here are Today's top Matches for you. Connect with them now!</h5>

                            <Row className="unique-match-card">
                                <Col lg={12} md={12} sm={12} className="match-photo">
                                    <div className="image-container">
                                        {showPhoto === "show" && match?.photos[0]?.url !== "sample-image.png" ? (<Slide>
                                            {match?.photos.map((photo, index) => {
                                                return (
                                                    <div key={index} className="each-slide-effect">
                                                        <div>
                                                            <Image fluid={true} src={`${key}/images/${photo?.url}`} alt="samp" />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </Slide>) : <img fluid={true} src={`${key}/images/${match?.photos[0]?.url}`} alt="samp" />}
                                        {showPhoto === "premium" && <div className="image-overlay">
                                            <img fluid={true} src={`${key}/images/${match?.photos[0]?.url}`} alt="samp" />
                                            <Link to="/pricing-table" className='button'>Buy Premium to View Images</Link>
                                        </div>}
                                        {showPhoto === "like" && <div className="image-overlay">
                                            <img fluid={true} src={`${key}/images/${match?.photos[0]?.url}`} alt="samp" />
                                            <Link className='button'>You need to connect with this member to View Images</Link>
                                        </div>}
                                        {showPhoto === "hide" && <div className="image-overlay">
                                            <img fluid={true} src={`${key}/images/${match?.photos[0]?.url}`} alt="samp" />
                                            <Link className='button'>Photo is Hide by the Member itself</Link>
                                        </div>}
                                    </div>
                                    {!showBadge && <div className="image-tag">Premium <FaCrown /></div>}
                                </Col>
                                <div className="match-card-header mx-auto">
                                    <div className="d-flex justify-content-around">
                                        <div className="match-name">{match?.firstName} {match?.lastName} {match?.userStatus?.isVerified && <BsShieldFillCheck className='secondary' />} <span>{match?.userId}</span></div>
                                        <Dropdown
                                            menu={{
                                                items: premiums,
                                            }}
                                        >
                                            <Link>
                                                <Space>
                                                    <FiArrowDownCircle size={25} />
                                                </Space>
                                            </Link>
                                        </Dropdown>
                                    </div>
                                    {/* <div className='d-flex justify-content-center status'>
                                    <div>{match?.userStatus?.isOnline ? <HiStatusOnline className='text-success' /> : <HiStatusOnline className='text-danger' />} {match?.userStatus?.isOnline ? 'Online Now' : 'Offline'}</div>
                                </div> */}
                                </div>
                                <Col lg={12} md={12} sm={12} className="match-info">
                                    <div className="match-card-body text-center">
                                        <Row className=''>
                                            <Col>
                                                {!loading && <div>{db} yrs, {match?.personalDetails?.height}</div>}
                                                <div>{match?.personalDetails?.religion}, {match?.personalDetails?.community}</div>
                                                <div>{match?.personalDetails?.motherTongue}</div>
                                                <div>{match?.personalDetails?.residencyStatus}</div>
                                            </Col>
                                            <Col className=''>
                                                <div>{match?.personalDetails?.maritalStatus}</div>
                                                <div>{match?.personalDetails?.cityLiving}, {match?.personalDetails?.countryLiving}</div>
                                                <div>{match?.personalDetails?.bodyType}</div>
                                                <div className='badge bg-success text-white fw-bold'>Looking for: {match?.lookingFor}</div>
                                            </Col>
                                        </Row>
                                        <div className='match-about'>{match?.personalDetails?.aboutMe}</div>
                                    </div>
                                </Col>
                                {isConnected ? <Col className='connect-button-container d-flex justify-content-center' lg={12} md={12} sm={12} >
                                    <Link className='chat-now-button' to="/chat" ><BsChatHeart />Chat Now</Link>
                                </Col>
                                    :
                                    <Col className='connect-button-container d-flex justify-content-center' lg={12} md={12} sm={12} >
                                        <button className='connect-now-button' onClick={() => handleConnect(match?._id)}><FaRegCheckCircle />Connect Now</button>
                                    </Col>}
                            </Row>
                            <Tabs className='backgroundLight match-detailed-profile-container' defaultActiveKey="1">
                                <TabPane tab="Detailed Profile" key="1">
                                    <About match={match} />
                                    <Hobbies match={match} />
                                    <ContactDetails match={match} isConnected={false} />
                                    <Lifestyle match={match} />
                                    <Background match={match} />
                                    <FamilyDetails match={match} />
                                    <EducationCareer match={match} />
                                </TabPane>
                                <TabPane tab="Partner Preferences" key="2">
                                    <LookingFor match={match} points={points} />
                                </TabPane>
                            </Tabs>
                        </Col>
                    </Row>
                </div>}
        </>
    )
}

export default ViewProfile